module.exports = __webpack_public_path__ + "img/ka13.d881414b.jpg";